class SkinQuizController {
  constructor(root) {
    this.root = root;
    this.form = root.querySelector('[data-sq-quiz-form]');
    this.steps = [...root.querySelectorAll('[data-sq-question]')];
    this.index = 0;
    this.copy = JSON.parse(root.querySelector('[data-sq-quiz-copy]').textContent);
    root.querySelector('[data-sq-next]').addEventListener('click', () => {
      if (this.validate()) { this.index += 1; this.renderStep(); }
    });
    root.querySelector('[data-sq-prev]').addEventListener('click', () => { this.index -= 1; this.renderStep(); });
    this.form.addEventListener('change', () => { root.querySelector('[data-sq-quiz-error]').hidden = true; });
    this.form.addEventListener('submit', event => {
      event.preventDefault();
      if (!this.validate()) return;
      if (this.index < 5) { this.index += 1; this.renderStep(); }
      else this.showResult();
    });
    root.querySelector('[data-sq-restart]').addEventListener('click', () => {
      this.form.reset(); this.index = 0; this.form.hidden = false;
      root.querySelector('[data-sq-result]').hidden = true; this.renderStep();
    });
    this.renderStep(false);
  }
  validate() {
    const answered = this.steps[this.index].querySelector('input:checked');
    this.root.querySelector('[data-sq-quiz-error]').hidden = !!answered;
    if (!answered) this.steps[this.index].querySelector('input').focus();
    return !!answered;
  }
  renderStep(focus = true) {
    this.steps.forEach((step, i) => { step.hidden = i !== this.index; });
    this.root.querySelector('[data-sq-step]').textContent = `${this.index + 1} / 6`;
    this.root.querySelector('[data-sq-progress]').value = this.index + 1;
    this.root.querySelector('[data-sq-prev]').hidden = this.index === 0;
    this.root.querySelector('[data-sq-next]').hidden = this.index === 5;
    this.root.querySelector('[data-sq-submit]').hidden = this.index !== 5;
    this.root.querySelector('[data-sq-quiz-error]').hidden = true;
    if (focus) this.steps[this.index].querySelector('legend').focus();
  }
  showResult() {
    const answers = Object.fromEntries(new FormData(this.form));
    const scores = { dry: 0, oily: 0, combination: 0, normal: 0 };
    ['q1', 'q2', 'q3'].forEach(key => { if (answers[key] in scores) scores[answers[key]] += 1; });
    const sorted = Object.entries(scores).sort((a, b) => b[1] - a[1]);
    const type = sorted[0][1] >= 2 ? sorted[0][0] : 'unknown';
    const concern = answers.q5;
    this.root.querySelector('[data-sq-result-title]').textContent = this.copy[type].title;
    this.root.querySelector('[data-sq-result-text]').textContent = this.copy[type].text;
    this.root.querySelector('[data-sq-sensitive]').hidden = answers.q4 !== 'yes';
    this.root.querySelector('[data-sq-texture]').textContent = this.copy[`texture_${answers.q6}`];
    this.root.querySelectorAll('[data-sq-concern]').forEach(link => {
      link.hidden = link.dataset.sqConcern !== concern && !(answers.q4 === 'yes' && link.dataset.sqConcern === 'sensitive');
    });
    this.form.hidden = true;
    this.root.querySelector('[data-sq-result]').hidden = false;
    this.root.querySelector('[data-sq-result-title]').focus();
  }
}
function initializeSkinQuiz(container = document) {
  container.querySelectorAll('[data-sq-quiz]').forEach(root => {
    if (!root.dataset.sqInitialized) { root.dataset.sqInitialized = 'true'; new SkinQuizController(root); }
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeSkinQuiz());
else initializeSkinQuiz();
document.addEventListener('shopify:section:load', event => initializeSkinQuiz(event.target));
